export const components = {
  header: {
    profile: 'Profile',
    settings: 'Settings',
    logout: 'Logout',
  },
  footer: {
    copyright: 'All rights reserved.',
  },
};
